import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  triggerPopupDisplayScreenChange,
  triggerPopupCloseScreenChange,
} from '@axa-asia/hk-emma-web-module/lib/ga-lib/GaPreviousScreenUtil';
import './style.scss';
import {
  getContactDetailsLabels,
  getContactDetailsPolicy,
} from '../../selectors/contactDetailsSelector';
import { isApp, resolveLocalizedText } from '../../../../utils';
import { getErrorCode } from '../../utils';
import { goto } from '../../../../actions/historyActions';
import { t } from '../../../../locales';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import _ from 'lodash';
import {
  fetchPolicyCards,
  saveSelectedPolicy,
} from '../../actions/changeContactAction';
import {
  resetChangeEmailForm,
  updateNewEmail,
} from '../../actions/changeEmailAction';
import {
  resetChangeMobileForm,
  updateNewMobile,
} from '../../actions/changeMobileAction';
import BackNavButton from '../../components/BackNavButton';
import EmmaNavTitle from '../../../../components/EmmaNavTitle';
import CustomerProfileTitle from '../../components/CustomerProfileTitle';
import browserHistory from '../../../../stores/browserHistory';
import { extractCountryCode } from '../../../../utils/common';
import { controlTopbarOverlay } from '../../../../utils/AppUtils';
import { getChangeMobileLabels } from '../../selectors/updateMobileSelector';
import { UserTypeCodes, ContactInfoStatuses } from '../../constants/constants';
import {
  ContactInfoStatusType,
  UserTypes,
} from '../../types/changeContactService';
import { EntityCode } from '../../../../types/entityCodeTypes';
import { ENTITY_CODE } from '../../../../constants/constants';
import {
  ADDRESS_ERROR_CICER21,
  ADDRESS_ERROR_CICER22,
  ADDRESS_ERROR_CICER25,
  ADDRESS_ERROR_CICER24,
  HAPPY_HK_CASE,
} from '../../constants/constants';
import { setUpIsHKAddressCase } from '../../actions/changeAddressAction';
import { getIsGoogleMapJsScriptComplete } from '../../selectors/changeAddressSelector';
import {
  gaClickAbleElement,
  trackDisplayErrorSuccess,
} from '../../../../utils/generalGaEventAnalytics';
import {
  EmmaButton,
  EmmaCol,
  EmmaListing,
  EmmaRadioSection,
  EmmaRow,
  EmmaSpace,
  EmmaText,
} from '@axa-asia/emma-stylesheet';
import classNames from 'classnames';
import { getRenewalUpdateLabels } from '../../selectors/renewalUpdateSelector';

export interface RenewalUpdateContainerProps {
  ownProps: any;
  contactDetailsLabel: any;
  renewalUpdateLabels: any;
  policyCardLabel: any;
  policyDetails: any;
  changeMobileLabels: any;
  errorCodeCICER21Config: any;
  errorCodeCICER22Config: any;
  errorCodeCICER25Config: any;
  errorCodeCICER24Config: any;
  saveSelectedPolicy: (policy: any) => void;
  resetChangeEmailForm: () => void;
  resetChangeMobileForm: () => void;
  onSetUpIsHKAddressCase: (isHappyHKCase: boolean) => void;
  onFetchPolicyCards: () => void;
  updateNewEmail: (newEmail: string) => void;
  updateNewMobile: (newMobile: string, countryCode: string) => void;
}

export interface RenewalUpdateContainerState {
  downloadModal: boolean;
  inEligibleAddressUpdateReasonCode: string;
  inEligibleEmailMobileUpdateReasonCode: string;

  info: {
    formattedLoginIdMobile?: { countryCode: string; mobileNumber: string };
    formattedMobile?: { countryCode: string; mobileNumber: string };
    emailAddress?: string;
    emailUpdateStatus?: string;
    mobile?: string;
    mobileNumberUpdateStatus?: string;
    loginId?: string;
    isUpdateMobileAvailable?: boolean;
    isUpdateEmailAvailable?: boolean;
    isUpdateToLoginIdAvailable?: boolean;
  };

  updateRadio: string;
}

export class RenewalUpdateContainer extends Component<
  RenewalUpdateContainerProps,
  RenewalUpdateContainerState
> {
  constructor(props: RenewalUpdateContainerProps) {
    super(props);
    this.state = {
      downloadModal: false,
      inEligibleAddressUpdateReasonCode: '',
      inEligibleEmailMobileUpdateReasonCode: '',
      info: {},
      updateRadio: 'updateEmail',
    };
  }

  gotoUpdateMobile = () => {
    const { policyDetails } = this.props;
    const { inEligibleEmailMobileUpdateReasonCode } = policyDetails;
    // null will bypass default value in destructive assignment
    const mobile: string = policyDetails.mobile || '';

    const { countryCode } = extractCountryCode(mobile);

    if (mobile && countryCode === '') {
      this.setState({
        downloadModal: true,
      });
      controlTopbarOverlay(true);
    } else if (
      inEligibleEmailMobileUpdateReasonCode &&
      inEligibleEmailMobileUpdateReasonCode !== HAPPY_HK_CASE
    ) {
      this.setState({
        inEligibleEmailMobileUpdateReasonCode,
      });
      controlTopbarOverlay(true);
      triggerPopupDisplayScreenChange(inEligibleEmailMobileUpdateReasonCode);
      // #70
      trackDisplayErrorSuccess(inEligibleEmailMobileUpdateReasonCode);
    } else {
      goto('emma-customer-profile/renewalupdate/changemobile');
    }
  };

  gotoChangeEmail = () => {
    const { policyDetails } = this.props;
    const { inEligibleEmailMobileUpdateReasonCode } = policyDetails;
    if (
      inEligibleEmailMobileUpdateReasonCode &&
      inEligibleEmailMobileUpdateReasonCode !== HAPPY_HK_CASE
    ) {
      this.setState({
        inEligibleEmailMobileUpdateReasonCode,
      });
      triggerPopupDisplayScreenChange(inEligibleEmailMobileUpdateReasonCode);
      // #70
      trackDisplayErrorSuccess(inEligibleEmailMobileUpdateReasonCode);
    } else {
      goto('emma-customer-profile/renewalupdate/changeemail');
    }
  };

  goToNextStep = (updateRadio) => {
    const { updateNewEmail, updateNewMobile } = this.props;

    if (!updateRadio || !this.props.policyDetails) {
      return;
    }

    if (updateRadio === 'updateEmail') {
      this.props.saveSelectedPolicy(this.props.policyDetails);
      this.gotoChangeEmail();
    } else if (updateRadio === 'updateMobile') {
      this.props.saveSelectedPolicy(this.props.policyDetails);
      this.gotoUpdateMobile();
    } else {
      if (this.state.info.loginId.includes('@')) {
        this.props.saveSelectedPolicy({
          ...this.props.policyDetails,
          prefilledEmailAddress: this.state.info.emailAddress,
        });
        updateNewEmail(this.state.info.loginId);
        this.gotoChangeEmail();
      } else if (
        !this.state.info.loginId.includes('@') &&
        this.state.info.formattedLoginIdMobile.countryCode === '852'
      ) {
        updateNewMobile(
          this.state.info.formattedLoginIdMobile.mobileNumber,
          this.state.info.formattedLoginIdMobile.countryCode,
        );
        this.gotoUpdateMobile();
      }
    }
  };

  onChangeUpdateRadio = (e) => {
    this.setState({ updateRadio: e });
  };

  componentDidUpdate(prevProps) {
    if (!_.isEmpty(this.props.policyDetails)) {
      if (prevProps.policyDetails !== this.props.policyDetails) {
        this.props.saveSelectedPolicy(this.props.policyDetails);
      }
    }
  }

  componentDidMount() {
    const {
      resetChangeEmailForm,
      resetChangeMobileForm,
      policyDetails,
      saveSelectedPolicy,
      onFetchPolicyCards,
    } = this.props;

    onFetchPolicyCards();

    if (isApp()) {
      const title = t(`CUSTOMER_PROFILE_CONTACT_DETAILS_TITLE`);
      if (title) {
        EmmaFactory.createInstance().then((p) =>
          p.instance.setNavigationTitle(title),
        );
      }
    }

    EmmaFactory.createInstance().then((e) => {
      e.instance
        .getInfo()
        .then((res: any) => {
          const {
            emailAddress,
            emailUpdateStatus,
            mobile,
            mobileNumberUpdateStatus,
            loginId,
          } = JSON.parse(res) || {};

          let isUpdateMobileAvailable = true;
          let isUpdateEmailAvailable = true;
          let isUpdateToLoginIdAvailable = false;
          // let loginIdCountryCode = '';
          let formattedLoginIdMobile = { countryCode: '', mobileNumber: '' };

          const formattedMobile = extractCountryCode(mobile);
          const isMobileValid = formattedMobile.countryCode === '852';

          // disable update email when updating
          if (emailUpdateStatus === 'P') {
            isUpdateEmailAvailable = false;
          }

          // disable update email when updating / invalid
          if (mobileNumberUpdateStatus === 'P' || (!isMobileValid && mobile)) {
            isUpdateMobileAvailable = false;
          }

          // enable update with LoginId
          if (
            (!emailAddress && !isMobileValid && mobile) ||
            (!emailAddress && !mobile)
          ) {
            // check LoginId Mobile Valid
            if (!loginId.includes('@')) {
              const extracted = extractCountryCode(loginId);
              // loginIdCountryCode = extracted.countryCode;
              formattedLoginIdMobile = extracted;

              isUpdateToLoginIdAvailable = extracted.countryCode === '852';
            } else {
              isUpdateToLoginIdAvailable = true;
            }
          }

          if (!isUpdateEmailAvailable) {
            this.setState({
              updateRadio: isUpdateMobileAvailable ? 'updateMobile' : '',
            });
          }

          this.setState({
            info: {
              formattedLoginIdMobile: formattedLoginIdMobile,
              formattedMobile: formattedMobile,
              // extractedMobile: extractedMobile,
              // loginIdCountryCode: loginIdCountryCode,
              // mobileCountryCode: countryCode,
              emailAddress: emailAddress,
              emailUpdateStatus: emailUpdateStatus,
              mobile: mobile,
              mobileNumberUpdateStatus: mobileNumberUpdateStatus,
              loginId: loginId,
              isUpdateMobileAvailable: isUpdateMobileAvailable,
              isUpdateEmailAvailable: isUpdateEmailAvailable,
              isUpdateToLoginIdAvailable: isUpdateToLoginIdAvailable,
            },
          });
        })
        .catch((error) => {
          console.error(error);
        });
    });

    // goto('emma-customer-profile/changemobile');

    // if (_.isEmpty(policyDetails)) {
    //   goto('emma-change-contact', undefined, undefined, true);
    // } else {
    // saveSelectedPolicy(policyDetails);
    // }
    // saveSelectedPolicy(policyDetails);

    resetChangeEmailForm();
    resetChangeMobileForm();
  }

  onGoBack = () => {
    if (window && window.location.pathname.includes('/renewalupdate')) {
      EmmaFactory.createInstance().then((e) => {
        e.instance.navClose();
      });
      return;
    }

    browserHistory.goBack();
    // goto('emma-change-contact');
  };

  hideDownloadModal = () => {
    this.setState({ downloadModal: false });
    controlTopbarOverlay(false);
  };

  hideErrorModal = () => {
    this.setState({
      inEligibleAddressUpdateReasonCode: '',
      inEligibleEmailMobileUpdateReasonCode: '',
    });
    controlTopbarOverlay(false);
    triggerPopupCloseScreenChange();
  };

  render() {
    const { contactDetailsLabel, policyDetails, renewalUpdateLabels } =
      this.props;

    const {
      renewalUpdateTitle,
      mobileTitle,
      mobileProvideLabel,
      emailTitle,
      emailProvideLabel,
      loginIdTitle,
      remarksLabelTitle,
      remarksLabelListing1,
      remarksLabelListing2,
      nextButtonLabel,
      cancelButtonLabel,
    } = renewalUpdateLabels;

    const { title } = contactDetailsLabel;

    const pageTitle = title ? resolveLocalizedText(title) : '';
    const { updateRadio } = this.state;

    return (
      <div className="">
        <div className="customer-profile-backbutton">
          <BackNavButton onClick={this.onGoBack} blue title={t('BACK')} />
        </div>
        <div className="renewal-update-container">
          <EmmaNavTitle
            title={pageTitle}
            component={<CustomerProfileTitle customerTitle={pageTitle} />}
          />
          {!_.isEmpty(this.state.info) && !_.isEmpty(policyDetails) ? (
            <div
              className={classNames(
                EmmaSpace['ml8'],
                EmmaSpace['mr8'],
                EmmaSpace['mt4'],
              )}
            >
              <EmmaRow>
                <p
                  className={classNames(
                    EmmaText['SmallModuleTitle/ComplexContent/Left/MineShaft'],
                  )}
                >
                  {renewalUpdateTitle
                    ? resolveLocalizedText(renewalUpdateTitle)
                    : ''}
                </p>
              </EmmaRow>
              <EmmaRow>
                <EmmaRadioSection
                  alwaysShowDesc={true}
                  value={updateRadio}
                  items={[
                    {
                      id: 'updateEmail',
                      name: emailTitle ? resolveLocalizedText(emailTitle) : '',
                      children: (
                        <EmmaListing
                          listingStyle="DASH"
                          list={[
                            {
                              title: this.state.info.emailAddress
                                ? this.state.info.emailAddress
                                : resolveLocalizedText(emailProvideLabel),
                            },
                          ]}
                        />
                      ),
                    },
                    {
                      id: 'updateMobile',
                      name: mobileTitle
                        ? resolveLocalizedText(mobileTitle)
                        : '',
                      children: (
                        <EmmaListing
                          listingStyle="DASH"
                          list={[
                            {
                              title: this.state.info.mobile
                                ? `(${
                                    this.state.info.formattedMobile.countryCode
                                  }) 
                           ${this.state.info.formattedMobile.mobileNumber.slice(
                             0,
                             4,
                           )} 
                           ${this.state.info.formattedMobile.mobileNumber.slice(
                             4,
                             8,
                           )}`
                                : resolveLocalizedText(mobileProvideLabel),
                            },
                          ]}
                        />
                      ),
                    },
                    {
                      id: 'updateToLoginId',
                      name: loginIdTitle
                        ? resolveLocalizedText(loginIdTitle)
                        : '',
                      children: (
                        <EmmaListing
                          listingStyle="DASH"
                          list={[
                            {
                              title: this.state.info.loginId.includes('@')
                                ? this.state.info.loginId
                                : `(${
                                    this.state.info.formattedLoginIdMobile
                                      .countryCode
                                  }) 
                             ${this.state.info.formattedLoginIdMobile.mobileNumber.slice(
                               0,
                               4,
                             )} 
                             ${this.state.info.formattedLoginIdMobile.mobileNumber.slice(
                               4,
                               8,
                             )}`,
                            },
                          ]}
                        />
                      ),
                    },
                  ].filter((option) => {
                    if (
                      (option.id === 'updateEmail' &&
                        this.state.info.isUpdateEmailAvailable) ||
                      (option.id === 'updateMobile' &&
                        this.state.info.isUpdateMobileAvailable) ||
                      (option.id === 'updateToLoginId' &&
                        this.state.info.isUpdateToLoginIdAvailable)
                    ) {
                      return option;
                    }
                  })}
                  noIndent={false}
                  onChange={this.onChangeUpdateRadio}
                />
              </EmmaRow>
              <EmmaRow
                className={classNames(EmmaSpace['mb48'], EmmaSpace['mt24'])}
              >
                <span
                  className={classNames([
                    EmmaText['Remarks_Error/Loose/Left/MineShaft'],
                    EmmaSpace['mb16'],
                  ])}
                >
                  {resolveLocalizedText(remarksLabelTitle)}
                </span>
                <EmmaListing
                  listingSize="sm"
                  list={[
                    {
                      title: (
                        <span
                          className={
                            EmmaText['Remarks_Error/Loose/Left/MineShaft']
                          }
                        >
                          {resolveLocalizedText(remarksLabelListing1)}
                        </span>
                      ),
                    },
                    {
                      title: (
                        <span
                          className={
                            EmmaText['Remarks_Error/Loose/Left/MineShaft']
                          }
                        >
                          {resolveLocalizedText(remarksLabelListing2)}
                        </span>
                      ),
                    },
                  ]}
                  listingStyle="NUMBER"
                />
              </EmmaRow>
              <EmmaRow
                className={classNames(
                  'align-items-center',
                  'flex-column',
                  'd-flex',
                )}
              >
                <div className={EmmaSpace['mb16']}>
                  <EmmaButton
                    variant="primary"
                    onClick={() => this.goToNextStep(this.state.updateRadio)}
                    disabled={!this.state.updateRadio}
                  >
                    {resolveLocalizedText(nextButtonLabel)}
                  </EmmaButton>
                </div>
                <EmmaButton variant="primary" outline onClick={this.onGoBack}>
                  {resolveLocalizedText(cancelButtonLabel)}
                </EmmaButton>
              </EmmaRow>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const { policy_number } = ownProps.match.params;
    const contactDetailsLabel = getContactDetailsLabels(state);
    const renewalUpdateLabels = getRenewalUpdateLabels(state);
    const policyDetails = getContactDetailsPolicy(state, policy_number);
    const changeMobileLabels = getChangeMobileLabels(state);
    const errorCodeCICER21Config = getErrorCode(ADDRESS_ERROR_CICER21, state);
    const errorCodeCICER22Config = getErrorCode(ADDRESS_ERROR_CICER22, state);
    const errorCodeCICER24Config = getErrorCode(ADDRESS_ERROR_CICER24, state);
    const errorCodeCICER25Config = getErrorCode(ADDRESS_ERROR_CICER25, state);
    return {
      ownProps,

      policyNumber: policy_number,
      policyDetails,
      contactDetailsLabel,
      renewalUpdateLabels,
      changeMobileLabels,
      errorCodeCICER21Config,
      errorCodeCICER22Config,
      errorCodeCICER24Config,
      errorCodeCICER25Config,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      updateNewEmail: (newEmail: string) => dispatch(updateNewEmail(newEmail)),
      updateNewMobile: (newMobile: string, countryCode: string) =>
        dispatch(updateNewMobile(newMobile, countryCode)),
      saveSelectedPolicy: (policy: any) => dispatch(saveSelectedPolicy(policy)),
      resetChangeEmailForm: () => dispatch(resetChangeEmailForm()),
      resetChangeMobileForm: () => dispatch(resetChangeMobileForm()),
      onSetUpIsHKAddressCase: (isHappyHKCase: boolean) => {
        dispatch(setUpIsHKAddressCase(isHappyHKCase));
      },
      onFetchPolicyCards: (params: any) => dispatch(fetchPolicyCards(params)),
    };
  }
}

export default connect(
  RenewalUpdateContainer.mapStateToProps,
  RenewalUpdateContainer.mapDispatchToProps,
)(RenewalUpdateContainer);
